module.exports = __webpack_public_path__ + "img/r_img.6e1c10d8.png";